import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { trackEvent } from '../../../../../../utils/Stats';
import './MuteSwitch.css';
import * as SoundManager from '../../../../../../utils/SoundManager';
import * as Features from '../../../../../../utils/Features';
import { soundBlocked } from '../../../../../../redux/actions';

class MuteSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      muted: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.soundBlockState === true) {
      // try to play sound
      this.props.soundBlocked(SoundManager.muteAtmo(false));
    } else {
      // mute switch
      this.setState({
        muted: SoundManager.muteSwitch(),
      });
      trackEvent('btn', 'sound');
    }
  }
  render() {
    const { active, soundBlockState } = this.props;

    return (
      <button
        id="mute-switch"
        className={`${this.state.muted ? 'muted' : ''} ${
          active ? 'active' : ''
        } ${soundBlockState ? 'locked' : ''} ${
          Features.features.mobile ? '' : 'desktop'
        }`}
        onClick={this.handleClick}
      >
        <img
          className="mute-ico"
          src={`${ASSETS_FOLDER}img/ico/btn-mute.png`}
          alt=""
        />
      </button>
    );
  }
}

const mapStateToProps = state => ({
  soundBlockState: state.app.soundBlockState,
});

const mapDispatchToProps = dispatch => ({
  soundBlocked: soundBlockState => dispatch(soundBlocked(soundBlockState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MuteSwitch);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/MuteSwitch/MuteSwitch.js